import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Space,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Collapse,
  Descriptions,
  Flex,
  Divider,
  Checkbox,
  Radio,
  TimePicker,
  Dropdown,
  Tag,
  Popconfirm,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  addMaterialRequest,
  cancelMaterialRequest,
  getItemDetails,
  getStockItems,
  submitMaterialRequest,
  updateMaterialRequest,
} from '../../../network/materialRequest';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWarehouse } from '../../../network/warehouse';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getVATDetails } from '../../../network/purchaseOrder';
import {
  getDataApi,
  getGetDetailsApi,
  getSearchApi,
  getSearchApiSearchText,
} from '../../../network/itemList';
import { getSupplier } from '../../../network/supplier';
import ItemOrderList from '../AddPurchaseOrder/ItemOrderList';
import TaxtList from '../AddPurchaseOrder/TaxtList';
import {
  addPurchaseInvoice,
  deletePurchaseInvoice,
  getDebitNote,
  getMapReferenceRecieptAndInvoice,
  getPartyDetails,
  getPurchaseInvoiceDetails,
  updatePurchaseInvoice,
} from '../../../network/purchaseInvoice';
import { getAccounts } from '../../../network/PaymentEntry';
import PaymentSchedule from '../AddPurchaseOrder/PaymentSchedule';
import { getMapReferenceMakePI } from '../../../network/purchaseReciept';
import { MdNoteAlt, MdOutlinePayment, MdSubtitles } from 'react-icons/md';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { SiKnowledgebase } from 'react-icons/si';
import { GiFiles } from 'react-icons/gi';
import { getSearchPatients } from '../../../network/appointment';
import { BiShow } from 'react-icons/bi';
import { ModalAppPdfData } from '../ModalApp/ModalApp';
import UseDownloadPdf from '../../../hooks/DownloadPdf';
import HeadingApp from '../../../hooks/HeadingApp';
import { TbFileInvoice } from 'react-icons/tb';
const AddPurchaseInvoice = ({ t, edit, reciept, order, note, view }) => {
  const [form] = Form.useForm();
  const [searchTxtAccount, setSearchTxtAccount] = useState('');
  const navigate = useNavigate();
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const [nameInvoice, setNameInvoice] = useState('');
  const [openPdf, setOpenPdf] = useState(false);
  const [dataSourcePayment, setDataSourcePayment] = useState([
    {
      due_date: dayjs(),
      invoice_portion: 100,
    },
  ]);
  const [loadingTaxesDetails, setLoadingTaxesDetails] = useState(false);
  const [taxesDetails, setTaxesDetails] = useState([]);
  const [priceListSelect, setPriceListSelect] = useState();
  const [searchtextSupplier, setSearchtextSupplier] = useState('');
  const { id, idReciept, idOrder, idNote, idView } = useParams();
  const [dataSource, setDataSource] = useState([
    {
      warehouse: form.getFieldValue('set_warehouse'),
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { companyName, currentLang } = useSelector((state) => state.user);
  const client = useQueryClient();
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddPurchaseInvoice } = useMutation({
    mutationKey: ['addPurchaseInvoice'],
    mutationFn: (body) =>
      edit ? updatePurchaseInvoice(body, id) : addPurchaseInvoice(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(
        note
          ? 'Debit Note added successfully'
          : edit
          ? 'Updated successfully'
          : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/purchase-invoice');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      // console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Purchase Invoice', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      submitButton && navigate('/purchase-invoice');
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const {
    data: purchaseInvoiceDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getPurchaseInvoice, id],
    queryFn: () => getPurchaseInvoiceDetails(id),
    enabled: !!edit,
  });
  const {
    data: purchaseInvoiceDetailsView,
    isLoading: isLoadingPurchaseInvoiceDetailsView,
  } = useQuery({
    queryKey: [queryKeys.getPurchaseInvoiceView, idView],
    queryFn: () => getPurchaseInvoiceDetails(idView),
    enabled: !!view,
  });
  // const { data: creditData } = useQuery({
  //   queryKey: [queryKeys.getDataApi, 'Account'],
  //   queryFn: () => getDataApi('Account'),
  //   keepPreviousData: true,
  // });
  const { mutate: handleGetDetails } = useMutation({
    mutationKey: [queryKeys.getSearchApiAccountList],
    mutationFn: (values) =>
      getGetDetailsApi({
        type: 'Supplier',
        name: values,
        // fields: ['supplier_name', 'supplier_name_in_arabic'],
        fields: ['supplier_name'],
      }),
    onSuccess: (data) => {
      form.setFieldsValue({
        supplier_name: data?.message?.supplier_name,
        // supplier_name_in_arabic: data?.message?.supplier_name_in_arabic,
      });
    },
  });
  const { data: Supplier } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextSupplier],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Supplier',
        searchTxt: searchtextSupplier,
      }),
    keepPreviousData: true,

    enabled:
      searchtextSupplier?.length >= 3 || searchtextSupplier?.length === 0,
  });
  const { data: debitNoteDetails, isLoading: LoadingNoteDetails } = useQuery({
    queryKey: [queryKeys.getDebitNote, idNote],
    queryFn: () => getDebitNote(idNote),
    enabled: !!note,
  });
  const {
    data: mapReferenceRecieptAndInvoice,
    isLoading: isLoadingPurchaseInvoiceDetails,
  } = useQuery({
    queryKey: [queryKeys.getMapReferenceRecieptAndInvoiceReciept, idReciept],
    queryFn: () => getMapReferenceRecieptAndInvoice(idReciept),
    enabled: !!reciept,
  });
  const { onGetPDF, pdfData,setLoadingPdf,loadingPdf } = UseDownloadPdf();
  const {
    data: mapReferenceRecieptAndInvoiceOrder,
    isLoading: isLoadingPurchaseOrderDetails,
  } = useQuery({
    queryKey: [queryKeys.getMapReferenceRecieptAndInvoiceOrderPI, idOrder],
    // queryKey: [queryKeys.getMapReferenceRecieptAndInvoiceOrder, idOrder],
    queryFn: () => getMapReferenceMakePI(idOrder),
    // queryFn: () => getMapReferenceMakePR(idOrder),
    enabled: !!order,
  });
  const { mutate: onGetTaxes, data: taxesList } = useMutation({
    mutationFn: (name) => getVATDetails('Purchase', name),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingTaxesDetails(false);
      setTaxesDetails(data?.message);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { mutate: onGetTaxesDetails } = useMutation({
    mutationFn: (name) => getPartyDetails(name),
    onSuccess: (data) => {
      console.log(data, 'data');
      form.setFieldsValue({
        buying_price_list: data?.message?.buying_price_list,
        credit_to: data?.message?.credit_to,
        taxes_and_charges: data?.message?.tax_category,
      });
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const netTotalWatch = Form.useWatch('total', form);
  const disableRoundedTotalWatch = Form.useWatch('disable_rounded_total', form);
  const disountApplyType = Form.useWatch('discount_type', form);

  useEffect(() => {
    if (taxesList || dataSource) {
      const netTotal = form.getFieldValue('total');
      const disableRoundedTotal = form.getFieldValue('disable_rounded_total');
      const totalRate = taxesList?.message?.reduce(
        (sum, item) => sum + item?.rate,
        0
      );
      const taxAmount = (netTotal * totalRate) / 100;
      const grandTotal = netTotal + taxAmount;
      const roundedTotal = disableRoundedTotal
        ? Math.round(grandTotal)
        : grandTotal;
      const roundingAdjustment = (roundedTotal - grandTotal).toFixed(2);
      setDataSourcePayment(
        dataSourcePayment.map((item) => ({
          ...item,
          invoice_portion: 100,
          payment_amount: roundedTotal,
        }))
      );
      form.setFieldsValue({
        grand_total: grandTotal,
        total_taxes_and_charges: roundedTotal,
        rounded_total: roundedTotal,
        rounding_adjustment: roundingAdjustment,
      });
    }
  }, [taxesList, form, dataSource, netTotalWatch, disableRoundedTotalWatch]);

  const { data: warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouse],
    queryFn: () =>
      getWarehouse({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  // const { data: itemsList } = useQuery({
  //   queryKey: [queryKeys.getStockItems],
  //   queryFn: () => getStockItems(),
  //   keepPreviousData: true,
  // });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const { data: priceList } = useQuery({
    queryKey: [queryKeys.getPriceListSearch],
    queryFn: () => getSearchApi('Price List'),
    keepPreviousData: true,
  });
  const { data: taxesCharges } = useQuery({
    queryKey: [queryKeys.getItemTaxTemplate],
    queryFn: () => getSearchApi('Purchase Taxes and Charges Template'),
    keepPreviousData: true,
  });
  const { data: suppliers } = useQuery({
    queryKey: [queryKeys.getSupplier],
    queryFn: () =>
      getSupplier({
        key: '',
        value: '',
      }),
    keepPreviousData: true,
  });
  const accountFilter = '{"is_group":0}';
  // const { data: parties } = useQuery({
  //   queryKey: [queryKeys.getAccounts],
  //   queryFn: () => getAccounts(accountFilter),
  //   keepPreviousData: true,
  //   select: (data) => data?.message?.accounts,
  // });
  const { data: Account, isLoading: isLoadingAccount } = useQuery({
    queryKey: [queryKeys.getSearchAccount, searchTxtAccount],
    queryFn: () => getSearchPatients('Account', searchTxtAccount),
    enabled: searchTxtAccount?.length >= 2 || searchTxtAccount?.length === 0,
    keepPreviousData: true,
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Purchase Invoice', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500 || !data) {
        message.error(data?.message?.message || 'Error occured');
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleRemove = useMutation({
    mutationFn: (id) => deletePurchaseInvoice(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (note && debitNoteDetails) {
      setTaxesDetails(debitNoteDetails?.message?.taxes);
      onGetTaxes(debitNoteDetails?.message?.taxes_and_charges);
      setDataSourcePayment(
        debitNoteDetails?.message?.payment_schedule?.length
          ? debitNoteDetails?.message?.payment_schedule?.map((payment) => ({
              ...payment,
              invoice_portion: 100,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      setDataSource(
        debitNoteDetails?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...debitNoteDetails?.message,
        grand_total: Number(debitNoteDetails?.message?.grand_total),
        rounding_adjustment: Number(
          debitNoteDetails?.message?.rounding_adjustment
        ),
        rounded_total: Number(debitNoteDetails?.message?.rounded_total),
        disable_rounded_total: Number(
          debitNoteDetails?.message?.disable_rounded_total
        ),
        base_discount_amount: Number(
          debitNoteDetails?.message?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          debitNoteDetails?.message?.additional_discount_percentage
        ),
        posting_date: dayjs(debitNoteDetails?.message?.posting_date),
        posting_time: dayjs(debitNoteDetails?.message?.posting_time, 'HH:mm'),
        due_date: dayjs(debitNoteDetails?.message?.due_date),
        payment_schedule: debitNoteDetails?.message?.payment_schedule?.map(
          (payment) => ({ ...payment, due_date: dayjs(payment?.due_date) })
        ) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [note, debitNoteDetails, form]);
  useEffect(() => {
    if (edit && purchaseInvoiceDetails) {
      setDataStatus(purchaseInvoiceDetails?.data?.docstatus);
      setTaxesDetails(purchaseInvoiceDetails?.data?.taxes);
      onGetTaxes(purchaseInvoiceDetails?.data?.taxes_and_charges);
      setDataSourcePayment(
        purchaseInvoiceDetails?.data?.payment_schedule?.length
          ? purchaseInvoiceDetails?.data?.payment_schedule?.map((payment) => ({
              ...payment,
              due_date: dayjs(payment?.due_date),
            }))
          : [{}]
      );
      setDataSource(
        purchaseInvoiceDetails?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseInvoiceDetails?.data,
        grand_total: Number(purchaseInvoiceDetails?.data?.grand_total),
        rounding_adjustment: Number(
          purchaseInvoiceDetails?.data?.rounding_adjustment
        ),
        rounded_total: Number(purchaseInvoiceDetails?.data?.rounded_total),
        disable_rounded_total: Number(
          purchaseInvoiceDetails?.data?.disable_rounded_total
        ),
        base_discount_amount: Number(
          purchaseInvoiceDetails?.data?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          purchaseInvoiceDetails?.data?.additional_discount_percentage
        ),
        posting_date: dayjs(purchaseInvoiceDetails?.data?.posting_date),
        posting_time: dayjs(
          purchaseInvoiceDetails?.data?.posting_time,
          'HH:mm'
        ),
        due_date: dayjs(purchaseInvoiceDetails?.data?.due_date),
        payment_schedule: purchaseInvoiceDetails?.data?.payment_schedule?.map(
          (payment) => ({ ...payment, due_date: dayjs(payment?.due_date) })
        ) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [edit, purchaseInvoiceDetails, form]);
  useEffect(() => {
    if (view && purchaseInvoiceDetailsView) {
      setTaxesDetails(purchaseInvoiceDetailsView?.data?.taxes);
      onGetTaxes(purchaseInvoiceDetailsView?.data?.taxes_and_charges);
      setDataSourcePayment(
        purchaseInvoiceDetailsView?.data?.payment_schedule?.length
          ? purchaseInvoiceDetailsView?.data?.payment_schedule?.map(
              (payment) => ({
                ...payment,
                due_date: dayjs(payment?.due_date),
              })
            )
          : [{}]
      );
      setDataSource(
        purchaseInvoiceDetailsView?.data?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...purchaseInvoiceDetailsView?.data,
        grand_total: Number(purchaseInvoiceDetailsView?.data?.grand_total),
        rounding_adjustment: Number(
          purchaseInvoiceDetailsView?.data?.rounding_adjustment
        ),
        rounded_total: Number(purchaseInvoiceDetailsView?.data?.rounded_total),
        disable_rounded_total: Number(
          purchaseInvoiceDetailsView?.data?.disable_rounded_total
        ),
        base_discount_amount: Number(
          purchaseInvoiceDetailsView?.data?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          purchaseInvoiceDetailsView?.data?.additional_discount_percentage
        ),
        posting_date: dayjs(purchaseInvoiceDetailsView?.data?.posting_date),
        posting_time: dayjs(
          purchaseInvoiceDetailsView?.data?.posting_time,
          'HH:mm'
        ),
        due_date: dayjs(purchaseInvoiceDetailsView?.data?.due_date),
        payment_schedule:
          purchaseInvoiceDetailsView?.data?.payment_schedule?.map(
            (payment) => ({ ...payment, due_date: dayjs(payment?.due_date) })
          ) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [view, purchaseInvoiceDetailsView, form]);
  useEffect(() => {
    if (reciept && mapReferenceRecieptAndInvoice) {
      setTaxesDetails(mapReferenceRecieptAndInvoice?.message?.taxes);
      onGetTaxes(mapReferenceRecieptAndInvoice?.message?.taxes_and_charges);
      setDataSourcePayment(
        mapReferenceRecieptAndInvoice?.message?.payment_schedule?.length
          ? mapReferenceRecieptAndInvoice?.message?.payment_schedule?.map(
              (payment) => ({
                ...payment,
                due_date: dayjs(payment?.due_date),
                invoice_portion: 100,
              })
            )
          : [{}]
      );
      setDataSource(
        mapReferenceRecieptAndInvoice?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      form.setFieldsValue({
        ...mapReferenceRecieptAndInvoice?.message,
        grand_total: Number(
          mapReferenceRecieptAndInvoice?.message?.grand_total
        ),
        rounding_adjustment: Number(
          mapReferenceRecieptAndInvoice?.message?.rounding_adjustment
        ),
        rounded_total: Number(
          mapReferenceRecieptAndInvoice?.message?.rounded_total
        ),
        disable_rounded_total: Number(
          mapReferenceRecieptAndInvoice?.message?.disable_rounded_total
        ),
        base_discount_amount: Number(
          mapReferenceRecieptAndInvoice?.message?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          mapReferenceRecieptAndInvoice?.message?.additional_discount_percentage
        ),
        posting_date: dayjs(
          mapReferenceRecieptAndInvoice?.message?.posting_date
        ),
        posting_time: dayjs(
          mapReferenceRecieptAndInvoice?.message?.posting_time,
          'HH:mm'
        ),
        due_date: dayjs(mapReferenceRecieptAndInvoice?.message?.due_date),
        payment_schedule:
          mapReferenceRecieptAndInvoice?.message?.payment_schedule?.map(
            (payment) => ({ ...payment, due_date: dayjs(payment?.due_date) })
          ) || [{}],
      });
    } else if (order && mapReferenceRecieptAndInvoiceOrder) {
      setTaxesDetails(mapReferenceRecieptAndInvoiceOrder?.message?.taxes);
      onGetTaxes(
        mapReferenceRecieptAndInvoiceOrder?.message?.taxes_and_charges
      );
      setDataSource(
        mapReferenceRecieptAndInvoiceOrder?.message?.items?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date),
        })) || [{}]
      );
      setDataSourcePayment(
        mapReferenceRecieptAndInvoiceOrder?.message?.payment_schedule?.length
          ? mapReferenceRecieptAndInvoiceOrder?.message?.payment_schedule?.map(
              (payment) => ({
                ...payment,
                due_date: dayjs(payment?.due_date),
                invoice_portion: 100,
              })
            )
          : [{}]
      );
      form.setFieldsValue({
        ...mapReferenceRecieptAndInvoiceOrder?.message,
        grand_total: Number(
          mapReferenceRecieptAndInvoiceOrder?.message?.grand_total
        ),
        rounding_adjustment: Number(
          mapReferenceRecieptAndInvoiceOrder?.message?.rounding_adjustment
        ),
        rounded_total: Number(
          mapReferenceRecieptAndInvoiceOrder?.message?.rounded_total
        ),
        disable_rounded_total: Number(
          mapReferenceRecieptAndInvoiceOrder?.message?.disable_rounded_total
        ),
        base_discount_amount: Number(
          mapReferenceRecieptAndInvoiceOrder?.message?.base_discount_amount
        ),
        additional_discount_percentage: Number(
          mapReferenceRecieptAndInvoiceOrder?.message
            ?.additional_discount_percentage
        ),
        posting_date: dayjs(
          mapReferenceRecieptAndInvoiceOrder?.message?.posting_date
        ),
        posting_time: dayjs(
          mapReferenceRecieptAndInvoiceOrder?.message?.posting_time,
          'HH:mm'
        ),
        due_date: dayjs(mapReferenceRecieptAndInvoiceOrder?.message?.due_date),
        // payment_schedule: mapReferenceRecieptAndInvoiceOrder?.message?.payment_schedule?.map((payment) => ({ ...payment, due_date:dayjs(payment?.due_date)})) || [{}],
      });
    } else {
      form.resetFields();
    }
  }, [
    reciept,
    mapReferenceRecieptAndInvoice,
    form,
    mapReferenceRecieptAndInvoiceOrder,
  ]);
  const onFinish = (values) => {
    const totalPortion = dataSourcePayment?.reduce(
      (acc, curr) => acc + Number(curr?.invoice_portion),
      0
    );
    if (totalPortion !== 100) {
      return message.error('Total portion should be 100%');
    }
    setLoadingAdd(true);
    if (note) {
      onAddPurchaseInvoice({
        ...values,
        company: companyName,
        additional_discount_percentage: 0,
        base_discount_amount: 0,
        discount_amount: 0,
        set_posting_time: values?.set_posting_time ? 1 : 0,
        is_return: values?.is_return ? 1 : 0,
        update_stock: values?.update_stock ? 1 : 0,
        is_paid: values?.is_paid ? 1 : 0,
        on_hold: values?.on_hold ? 1 : 0,
        disable_rounded_total: values?.disable_rounded_total ? 1 : 0,
        total_taxes_and_charges: Number(values?.total_taxes_and_charges),
        grand_total: Number(values?.grand_total),
        rounding_adjustment: Number(values?.rounding_adjustment),
        rounded_total: Number(values?.rounded_total),
        // disable_rounded_total: Number(values?.disable_rounded_total),
        posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
        posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
        due_date: dayjs(values?.due_date).format('YYYY-MM-DD'),
        items: dataSource?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
        })),
        update_outstanding_for_self: 0,
        taxes: taxesList?.message?.map((tax) => ({ ...tax })),
        payment_schedule: dataSourcePayment?.map((payment) => ({
          invoice_portion: Number(payment?.invoice_portion),
          due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
          discount: Number(payment?.discount),
          payment_amount: Number(payment?.payment_amount),
          outstanding: Number(payment?.outstanding),
          paid_amount: Number(payment?.paid_amount),
          discounted_amount: Number(payment?.discounted_amount),
          base_payment_amount: Number(payment?.base_payment_amount),
          description: payment?.description,
        })),
        advances: [],
        pricing_rules: [],
        advance_tax: [],
        supplied_items: [],
        return_against: debitNoteDetails?.message?.return_against,
        purchase_invoice_item: debitNoteDetails?.message?.purchase_invoice_item,
        purchase_order: debitNoteDetails?.message?.purchase_order,
        purchase_receipt: debitNoteDetails?.message?.purchase_receipt,
      });
    } else {
      onAddPurchaseInvoice({
        ...values,
        company: companyName,
        additional_discount_percentage: 0,
        base_discount_amount: 0,
        discount_amount: 0,
        total_taxes_and_charges: Number(values?.total_taxes_and_charges),
        grand_total: Number(values?.grand_total),
        rounding_adjustment: Number(values?.rounding_adjustment),
        rounded_total: Number(values?.rounded_total),
        disable_rounded_total: Number(values?.disable_rounded_total),
        posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
        posting_time: dayjs(values?.posting_time).format('HH:mm:ss.SSSSSS'),
        due_date: dayjs(values?.due_date).format('YYYY-MM-DD'),
        items: dataSource?.map((item) => ({
          ...item,
          schedule_date: dayjs(item?.schedule_date).format('YYYY-MM-DD'),
        })),
        taxes: taxesList?.message?.map((tax) => ({ ...tax })),
        // payment_schedule:values.payment_schedule?.map((payment) => ({ invoice_portion:Number(payment?.invoice_portion), due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
        //   discount:Number(payment?.discount),
        //   payment_amount:Number(payment?.payment_amount),
        //   outstanding:Number(payment?.outstanding),
        //   paid_amount:Number(payment?.paid_amount),
        //   discounted_amount:Number(payment?.discounted_amount),
        //   base_payment_amount:Number(payment?.base_payment_amount),
        // })),
        payment_schedule: dataSourcePayment?.map((payment) => ({
          invoice_portion: Number(payment?.invoice_portion),
          due_date: dayjs(payment?.due_date).format('YYYY-MM-DD'),
          discount: Number(payment?.discount),
          payment_amount: Number(payment?.payment_amount),
          outstanding: Number(payment?.outstanding),
          paid_amount: Number(payment?.paid_amount),
          discounted_amount: Number(payment?.discounted_amount),
          base_payment_amount: Number(payment?.base_payment_amount),
          description: payment?.description,
        })),
        advances: [],
        pricing_rules: [],
        advance_tax: [],
        supplied_items: [],
      });
    }
  };
  if (
    isLoading ||
    isLoadingPurchaseInvoiceDetails ||
    isLoadingPurchaseOrderDetails ||
    LoadingNoteDetails ||
    isLoadingPurchaseInvoiceDetailsView
  ) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  const items = (record) => [
    {
      key: '1',
      label: t.view,
      icon: <BiShow />,
      onClick: () => {
        navigate(`/purchase-invoice/view/${record?.name}`);
      },
    },
    {
      key: '1-1',
      label: t.StockLedger,
      icon: <SiKnowledgebase />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/stock-ledger-report-invoice/${record?.name}`),
    },
    {
      key: '1-2',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/general-ledger-report-invoice/${record?.name}`),
    },
    {
      key: '6-1',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        // onGetPDF(record.name);
        onGetPDF({
          type: 'Purchase Invoice',
          // name: nameInvoice,
          name: record.name,
          lang: 'ar',
          format: '',
        });
        setOpenPdf(true);
        setNameInvoice(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '3',
      label: t.Payment,
      icon: <MdOutlinePayment />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => {
        navigate(`/payment-entry/purchase-invoice/${record?.name}`);
      },
    },
    {
      key: '1-3',
      label: t.debitNote,
      icon: <MdNoteAlt />,
      disabled:
        record?.status !== 'Draft'
          ? false
          : record?.status !== 'Return'
          ? false
          : record?.status !== 'Debit Note Issued'
          ? false
          : true,
      onClick: () =>
        navigate(`/purchase-invoice/add-debit-note/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      disabled: record?.status === 'Draft' ? false : true,
      onClick: () => handleSubmit.mutate(record?.name),
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      // disabled: record?.status === 'Draft' ? false : true,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancle.mutate(record?.name),
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  console.log(
    purchaseInvoiceDetails?.data?.docstatus,
    'purchaseInvoiceDetails?.data?.docstatus'
  );

  const itemsMenu = [
    {
      key: '1',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<MdSubtitles />}
          disabled={
            purchaseInvoiceDetails?.data?.status === 'Draft' ? false : true
          }
        >
          {t.submit}
        </Button>
      ),
      onClick: () => {
        // handleSubmit.mutate(purchaseInvoiceDetails?.data?.name);
        handleSubmit.mutate(id);
      },
    },
    {
      key: '2',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<SiKnowledgebase />}
          disabled={
            purchaseInvoiceDetails?.data?.docstatus === 1 ? false : true
          }
        >
          {t.StockLedger}
        </Button>
      ),
      onClick: () => {
        navigate(`/stock-ledger-report-invoice/${id}`);
      },
    },
    {
      key: '3',
      label: (
        <Button
          size="small"
          type="text"
          style={{ width: '100%' }}
          icon={<GiFiles />}
          disabled={
            purchaseInvoiceDetails?.data?.docstatus === 1 ? false : true
          }
        >
          {t.GeneralLedger}
        </Button>
      ),
      onClick: () => {
        navigate(`/general-ledger-report-invoice/${id}`);
      },
    },
    // {
    //   key: '2',
    //   label: (
    //     <Button
    //     size="small"
    //     type="text"
    //      icon={<MdNoteAlt  />}
    //      disabled={purchaseInvoiceDetails?.data?.status === "Draft" ? true : false}
    //     >
    //       {t.debitNote}
    //     </Button>
    //   ),
    //   onClick:() => {
    //     // handleDebitNote.mutate(purchaseInvoiceDetails?.data?.name);
    //     handleDebitNote.mutate(id);
    //   }
    // },
  ];
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={
          edit
            ? t.editPurchaseInvoice
            : note
            ? t.returnPurchaseInvoice
            : t.addPurchaseInvoice
        }
        path="/purchase-invoice"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.PurchaseInvoice}
        subTitle={
          edit
            ? t.editPurchaseInvoice
            : note
            ? t.returnPurchaseInvoice
            : t.addPurchaseInvoice
        }
        icon={<TbFileInvoice />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Flex justify="end" align="center">
          {edit && (
            // <Dropdown menu={{ items: itemsMenu }} trigger={['click']} arrow>
            <Dropdown
              menu={{ items: items(purchaseInvoiceDetails?.data) }}
              trigger={['click']}
              arrow
            >
              <Button size="small" type="text" className="btn-light">
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
          {purchaseInvoiceDetailsView?.data?.is_return ? (
            <Tag color="magenta">Return Invoice</Tag>
          ) : null}
        </Flex>

        <Form
          form={form}
          name="add-purchase-invoice"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            taxes: [{}],
            payment_schedule: [{}],
            items: [{}],
          }}
          disabled={view}
          style={{
            marginTop: '20px',
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier"
                    label={t.Supplier}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Supplier}
                      style={{ width: '100%' }}
                      showSearch
                      filterOption={false}
                      popupMatchSelectWidth={false}
                      // options={customer?.message?.map((item) => ({
                      //   value: item?.value,
                      //   label: item?.value,
                      // }))}
                      onChange={(value) => {
                        handleGetDetails(value);
                      }}
                      onSearch={(value) => setSearchtextSupplier(value)}
                    >
                      {Supplier?.message?.map((item) => (
                        <Select.Option key={item?.value}>
                          <Flex gap={1} vertical>
                            <span>{item?.value}</span>
                            <span
                              className="item-description"
                              style={{ fontSize: '11px', color: 'gray' }}
                            >
                              {item?.description}
                            </span>
                          </Flex>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="supplier_name_in_arabic"
                    label={t.SupplierNameInArabic}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.SupplierNameInArabic} disabled />
                  </Form.Item>
                </Col> */}
                {purchaseInvoiceDetailsView?.data?.is_return ? (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="return_against" label={t.returnInvoiceId}>
                      <Input placeholder={t.returnInvoiceId} disabled />
                    </Form.Item>
                  </Col>
                ) : null}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="tax_id"
                    label={t.taxId}
                    // rules={[{ required: true }]}
                  >
                    <Input placeholder={t.taxId} disabled />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="due_date"
                    label={t.dueDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      // disabled={view}
                      placeholder={t.dueDate}
                      format="YYYY-MM-DD"
                      // disabledDate={(current) =>
                      //   current.endOf('d').valueOf() <
                      //   dayjs().endOf('d').valueOf()
                      // }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder={t.postingDate}
                      // disabled={view}
                      format="YYYY-MM-DD"
                      // disabledDate={(current) =>
                      //   current.endOf('d').valueOf() <
                      //   dayjs().endOf('d').valueOf()
                      // }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_time"
                    label={t.postingTime}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                    initialValue={dayjs()}
                  >
                    <TimePicker
                      style={{ width: '100%' }}
                      disabled={view}
                      placeholder={t.postingTime}
                      format="HH:mm"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="set_posting_time"
                    label={t.setPostingTime}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="is_return"
                    label={t.isReturn}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="update_stock"
                    label={t.updateStock}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="is_paid"
                    label={t.is_paid}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="disable_rounded_total"
                    label={t.disableRoundedTotal}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="on_hold"
                    label={t.onHold}
                    valuePropName="checked"
                    layout="horizontal"
                    // className='margin-bottom-0'
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.currencyAndPriceList}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="buying_price_list"
                    label={t.buyingPriceList}
                    // rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.buyingPriceList}
                      showSearch
                      disabled={view}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      onChange={(value, option) => {
                        setPriceListSelect(value);
                        form.setFieldsValue({
                          price_list_currency: option?.option?.description,
                          currency: option?.option?.description,
                        });
                      }}
                      options={priceList?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                        option: item,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="cost_center"
                    label={t.costCenter}
                    style={{ width: '100%', marginBottom: '0px' }}
                  >
                    <Select
                      placeholder={t.costCenter}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={costCenters?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="price_list_currency"
                label={t.priceListCurrency}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.priceListCurrency} disabled />
              </Form.Item>
            </Col> */}
                {/* <Divider /> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="base_discount_amount"
                label={t.baseDiscountAmount}
              >
              <Input 
                placeholder={t.baseDiscountAmount}
                type="number"
                 step="0.01"
              />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="discount_amount"
                label={t.discountAmount}
              >
              <Input 
                placeholder={t.discountAmount}
                type="number"
              />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item name="paid_amount" label={t.paidAmount}>
                <Input
                  placeholder={t.paidAmount}
                  type="number"
                  disabled={view}
                />
              </Form.Item>
            </Col> */}
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="additional_discount_percentage"
                label={t.additionalDiscountPercentage}
              >
              <Input 
                placeholder={t.additionalDiscountPercentage}
                type="number"
                min={0}
              />
              </Form.Item>
            </Col> */}

                <Divider orientation="left">{t.items}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="set_warehouse"
                    label={t.setWarehouse}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.setWarehouse}
                      style={{ width: '100%' }}
                      disabled={view}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setDataSource(
                          dataSource.map((item) => {
                            return {
                              ...item,
                              warehouse: value,
                            };
                          })
                        );
                      }}
                      options={warehouse?.data?.map((item) => ({
                        value: item?.name,
                        label: item?.warehouse_name,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} style={{ marginBottom: '20px' }}>
                  <ItemOrderList
                    type="Purchase Invoice"
                    keyData="Purchase Invoice"
                    priceList={priceListSelect}
                    setSelectedIndex={setSelectedIndex}
                    selectedIndex={selectedIndex}
                    dataSource={dataSource}
                    setDataSource={setDataSource}
                    form={form}
                    // itemsList={itemsList}
                    warehouse={warehouse}
                    t={t}
                    view={view}
                  />
                </Col>

                <Divider orientation="left">{t.TaxesandCharges}</Divider>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="taxes_and_charges"
                    label={t.TaxesandCharges}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.TaxesandCharges}
                      style={{ width: '100%' }}
                      disabled={view}
                      popupMatchSelectWidth={false}
                      onChange={(value) => {
                        setLoadingTaxesDetails(true);
                        onGetTaxes(value);
                      }}
                      options={taxesCharges?.message?.map((item) => ({
                        value: item?.value,
                        label: item?.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="company_trn"
                label={t.companyTrn}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input
                  placeholder={t.companyTrn}
                  type="number"
                  disabled={view}
                />
              </Form.Item>
            </Col> */}
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="credit_to"
                    label={t.creditTo}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t.creditTo}
                      style={{ width: '100%' }}
                      showSearch
                      allowClear
                      disabled={view}
                      optionFilterProp="children"
                      filterSort={false}
                      filterOption={false}
                      loading={isLoadingAccount}
                      popupMatchSelectWidth={false}
                      onSearch={(value) => {
                        setSearchTxtAccount(value);
                      }}
                      options={Account?.message?.map((account) => ({
                        value: account?.value,
                        label: account?.value,
                        data: account,
                      }))}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={12} md={8} xl={8} xxl={8}>
              <Form.Item
                name="against_expense_account"
                label={t.againstExpenseAccount}
              >
                <Select
                  placeholder={t.againstExpenseAccount}
                  style={{ width: '100%' }}
                  showSearch
                  optionFilterProp="children"
                  disabled={view}
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  popupMatchSelectWidth={false}
                  options={parties?.map((account) => ({
                    value: account?.name,
                    label: account?.account_name,
                    data: account,
                  }))}
                />
              </Form.Item>
            </Col> */}

                <Col span={24}>
                  <TaxtList
                    t={t}
                    form={form}
                    data={taxesDetails}
                    loadingTaxesDetails={loadingTaxesDetails}
                  />
                </Col>
                <Divider orientation="left">{t.paymentSchedule}</Divider>
                <Col span={24}>
                  <PaymentSchedule
                    dataSourcePayment={dataSourcePayment}
                    setDataSourcePayment={setDataSourcePayment}
                    t={t}
                    type="invoice"
                    form={form}
                    view={view}
                  />
                </Col>
                <Divider />
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total"
                    label={t.Total}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.Total}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_qty"
                    label={t.totalQty}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.totalQty}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="total_taxes_and_charges"
                    label={t.TotalTaxesandCharges}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.TotalTaxesandCharges}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="grand_total"
                    label={t.grandTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Input
                      placeholder={t.grandTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="rounding_adjustment"
                    label={t.roundingAdjustment}
                  >
                    <Input
                      placeholder={t.roundingAdjustment}
                      type="number"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="rounded_total"
                    label={t.roundedTotal}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                    disabled
                  >
                    <Input
                      placeholder={t.roundedTotal}
                      type="number"
                      min={0}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="in_words" label={t.inWords}>
                    <Input placeholder={t.inWords} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="total_advance" label={t.totalAdvance}>
                    <Input placeholder={t.totalAdvance} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="outstanding_amount"
                    label={t.outstandingAmount}
                  >
                    <Input placeholder={t.outstandingAmount} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="apply_discount_on"
                    label={t.applyDiscountOn}
                    // rules={[
                    //   {
                    //       required: true,
                    //     },
                    // ]}
                  >
                    <Select
                      placeholder={t.applyDiscountOn}
                      options={[
                        {
                          value: 'Grand Total',
                          label: t.GrandTotal,
                        },
                        {
                          value: 'Net Total',
                          label: t.netTotal,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="discount_type"
                    label={t.discountType}
                    // rules={[
                    //   {
                    //     required: true,
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={t.discountType}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: 'Percentage',
                          label: t.percentage,
                        },
                        {
                          value: 'Amount',
                          label: t.amount,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
                {disountApplyType === 'Amount' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item name="base_discount_amount" label={t.value}>
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                {disountApplyType === 'Percentage' && (
                  <Col xs={24} md={12} xl={8} xxl={8}>
                    <Form.Item
                      name="additional_discount_percentage"
                      label={t.value}
                    >
                      <Input
                        placeholder={t.value}
                        type="number"
                        // disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                <Divider orientation="left">{t.user_remark}</Divider>
                <Col span={24}>
                  <Form.Item
                    name="remarks"
                    label={t.remarks}
                    //  rules={[
                    //    {
                    //      required: true,
                    //    },
                    //  ]}
                    style={{ width: '100%' }}
                  >
                    <Input.TextArea
                      rows={4}
                      disabled={view}
                      placeholder={t.remarks}
                      style={{ width: '100%' }}
                      autoSize={{ minRows: 6, maxRows: 7 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.Cancel}
                </Button>
                {view ? null : (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (submitButton) {
                        setLoadingAdd(true);
                        handleSubmit.mutate(selectName);
                      } else {
                        form.submit();
                      }
                    }}
                    loading={loadingAdd}
                  >
                    {submitButton ? t.submit : edit ? t.edit : t.Save}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
        type="Purchase Invoice"
      />
    </>
  );
};

export default AddPurchaseInvoice;
